import React, { useContext } from 'react'
import Cross from './CrossIconSVG'
import { ClearTheChartsContext } from '../ClearTheChartsContext'

const initialChartProgress = {
  mistakenHands: {},
}

const MistakesRow = ({ chartId }) => {
  const { state } = useContext(ClearTheChartsContext)

  const { currentChartProgress } = state
  const { mistakenHands } =
    currentChartProgress[chartId] || initialChartProgress

  const mistakesCount = Object.keys(mistakenHands).length

  const renderMistakes = () => {
    return (
      <div
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          display: 'flex',
          columnGap: '10px',
        }}
      >
        {Array(mistakesCount)
          .fill('')
          .map((i, idx) => (
            <Cross color="red" />
          ))}
      </div>
    )
  }

  const renderEmptyCrosses = () => {
    const crossesCount = 5 - mistakesCount
    return (
      <div
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          display: 'flex',
          columnGap: '10px',
          marginLeft: mistakesCount > 0 ? '10px' : 0,
        }}
      >
        {Array(crossesCount)
          .fill('')
          .map((i, idx) => (
            <Cross />
          ))}
      </div>
    )
  }

  return (
    <div
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginLeft: '5px',
        display: 'flex',
      }}
    >
      {renderMistakes()}
      {renderEmptyCrosses()}
    </div>
  )
}

export default MistakesRow
